import { PaymentType } from '../api/payment/model'

export const getPaymentRefundLegalText = (
  timeFrame: number,
  paymentType: PaymentType
) => {
  switch (timeFrame) {
    case -1:
      return paymentType === PaymentType.DEPOSIT
        ? 'This deposit is non-refundable.'
        : 'This payment is non-refundable.'
    case 0:
      return paymentType === PaymentType.DEPOSIT
        ? 'This deposit is refundable until the time of your reservation.'
        : 'This payment is refundable until the time of your reservation.'
    default:
      return `Refundable if you cancel up to
          ${timeFrame} hours before your
          reservation time.`
  }
}
